module.exports = __webpack_public_path__ + "img/gestao-tempo.73d836e7.jpg";